export default __webpack_public_path__ + "static/freestocks-nss2eRzQwgw-unsplash-d90fab4889d03c93d6a0694ff94cde41.jpg";